import React from 'react'

import { Form, Col } from '_zari/core'

import { Field } from 'formik'


const FechaEmisionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    // <Form.Group>
    //   <Form.Label text='FEC. EMISION' htmlFor='input-fechaEmision' md={4} alignRightAt='md' />
    //   <Col md={8}>
    //     <Form.InputText name='fechaEmision' id='input-fechaEmision' />
    //   </Col>
    // </Form.Group>
    <Form.Group>
      <Form.Label text='FEC. EMISION' htmlFor='input-fechaEmision' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaEmision'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='input-fechaEmision'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
